<template>
  <div class="page-container">
    <!-- Your page content goes here -->
    <div class="page-content">
      <!-- Your page content elements -->
    </div>

    <!-- Footer -->
    <footer class="footer-info">
      <div class="footer-container">
        <div class="copyright">
          <div style="justify-content: center;">
            <div class="copyright-text" style="text-align: center; padding-top: 5px;">
              <p style="color: black;">{{ main_data }}</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- /Footer -->
  </div>
</template>

<script>
import config from "../../services/CommonApi";
import axios from "axios";

export default {
  data() {
    return {
      main_data: "",
      config: config,
    };
  },
  mounted() {
    this.get_practitioner_profile();
  },
  methods: {
    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].footer;
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
                       } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            } else if (window.location.hostname.startsWith("192.168")) {
            }else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }
          this.$swal.close();
        });
    },
  },
};
</script>

<style>
.page-container {
  display: flex;
  flex-direction: column;
  min-height: 22vh;
}

.page-content {
  flex-grow: 1;
}

.footer-info {
  background-color: #f8f8f8;
  margin-top: auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Footer.vue